function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { getIconButtonSize } from 'theming/tokens/components/button';
import { ReactComponent as ThreeDots } from 'assets/animations/three_dots.svg';
import * as S from './Button.styles';
const ButtonVariants = {
  primary: S.ButtonFilled,
  outline: S.ButtonOutline,
  text: S.ButtonText
};
const Button = /*#__PURE__*/React.forwardRef(({
  ariaLabel,
  children,
  size = 'medium',
  hasPadding = true,
  variant = 'primary',
  type = 'button',
  disabled,
  loading,
  width,
  leftIcon,
  rightIcon,
  ...props
}, ref) => {
  const ButtonComponent = ButtonVariants[variant];
  const iconDimension = getIconButtonSize(size);
  const loadingIndicator = /*#__PURE__*/React.createElement(ThreeDots, {
    width: iconDimension,
    height: iconDimension
  });
  const isInteractive = !(disabled || loading);
  return /*#__PURE__*/React.createElement(S.ButtonWrapper, {
    $disabled: !isInteractive,
    $width: width
  }, /*#__PURE__*/React.createElement(ButtonComponent, _extends({
    ref: ref,
    "aria-label": loading ? 'Loading' : ariaLabel,
    type: type,
    $size: size,
    $hasPadding: hasPadding,
    $disabled: disabled,
    $loading: loading,
    disabled: disabled
  }, props), loading ? loadingIndicator : /*#__PURE__*/React.createElement(React.Fragment, null, leftIcon ? /*#__PURE__*/React.createElement(S.IconContainer, {
    $buttonSize: size,
    $hasPadding: hasPadding,
    "aria-hidden": true
  }, leftIcon) : null, children, rightIcon ? /*#__PURE__*/React.createElement(S.IconContainer, {
    $buttonSize: size,
    $hasPadding: hasPadding,
    "aria-hidden": true
  }, rightIcon) : null)));
});
export { Button };